// Wording for identifiers, shared by every page that shows or edits them.

export const TYPE_LABELS = {
  email_domain: 'Email domain',
  web_domain: 'Website',
  email_address: 'Email address',
  phone: 'Phone number',
  bank: 'Bank account',
  social: 'Social account',
  url: 'Web page or booking link',
};

export const TYPE_HELP = {
  email_domain: { placeholder: 'techsummit.events', hint: 'Every address @ this domain counts as yours.' },
  web_domain: { placeholder: 'techsummit.events', hint: 'The site and all its subdomains.' },
  email_address: { placeholder: 'events.team@gmail.com', hint: 'One address, e.g. a shared inbox on a service you don’t own.' },
  phone: { placeholder: '020 7946 0018', hint: 'Include the country code if it’s outside the UK.' },
  bank: { placeholder: 'GB82 WEST 1234 5698 7654 32  or  12-34-56 12345678', hint: 'Stored only as a one-way fingerprint and the last four digits. Never listed publicly.' },
  social: { placeholder: 'https://www.linkedin.com/company/techsummit', hint: 'The full link to the profile.' },
  url: { placeholder: 'https://techsummit.events/hotels', hint: 'One page, e.g. the official hotel booking link.' },
};

export const VISIBILITY_OPTIONS = [
  { key: 'public', label: 'Show on the verify page', hint: 'Listed for everyone, and offered as the right place to go instead.' },
  { key: 'confirm_only', label: 'Confirm when asked, never list', hint: 'A check of this exact value says it’s yours; it’s never shown.' },
  { key: 'private', label: 'Private', hint: 'Only used inside SummitShield, never in an answer to anyone outside.' },
];

export const VISIBILITY_SHORT = { public: 'Public', confirm_only: 'Confirm only', private: 'Private' };

export const VERIFICATION = {
  verified: { tone: 'good', label: 'Verified' },
  pending: { tone: 'info', label: 'Checking' },
  failed: { tone: 'bad', label: 'Check failed' },
  expired: { tone: 'warn', label: 'Expired' },
  unverified: { tone: 'warn', label: 'Not verified' },
};

export const SOURCE_LABEL = { organisation: 'Company', brand: 'Brand', event: 'Event', person: 'Person', supplier: 'Supplier' };
